export default function filtersFn() {
  const mobFilter = {
    button: '.js-show-mob-filter',
    element: '.js-filter-dropdown',
    closeBtn: '.js-filter-dropdown-close'
  };

  const filtersMoreBtn = document.querySelector('.js-filters-more');
  const filters = document.querySelector('.js-filters');
  const filtersHideBtn = document.querySelector('.js-filters-hide');
  const filtersToogleBtn = document.querySelector('.js-filters-toggle');
  const showMobFilter = document.querySelector(mobFilter.button);
  const filterDropdown = document.querySelector(mobFilter.element);
  const filterDropdownCloneBtn = document.querySelector(mobFilter.closeBtn);

  if (filtersMoreBtn) {
    filtersMoreBtn.addEventListener('click', () => {
      filters.classList.add('is-expand');
    })
  }

  if (filtersHideBtn) {
    filtersHideBtn.addEventListener('click', () => {
      filters.classList.remove('is-expand');
    });
  }

  if (filtersToogleBtn) {
    filtersToogleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      filters.classList.toggle('is-expand');
    });
  }

  if (showMobFilter) {
    showMobFilter.addEventListener('click', () => {
      filterDropdown.style.display = 'block';
      filterDropdown.classList.add('is-open');
    });
  }

  if (filterDropdownCloneBtn) {
    filterDropdownCloneBtn.addEventListener('click', () => {
      filterDropdown.style.display = 'none';
      filterDropdown.classList.remove('is-open');
    })
  }

  document.addEventListener("click", (e) => {
    if (filterDropdown && filterDropdown.classList.contains('is-open')) {
      if (e.target.closest(mobFilter.button) || e.target.closest(mobFilter.element) || e.target.closest(mobFilter.closeBtn)) return;

      filterDropdown.classList.remove('is-open');
      filterDropdown.style.display = 'none';
    }
  })
}
